import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMeta from 'vue-meta'
import VueI18n from 'vue-i18n'
import en from './locales/en'
import vi from './locales/vi'
import ja from './locales/ja' // Added Japanese
import zh from './locales/zh' // Added Chinese

import './filters'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowDown,
  faSwimmer,
  faRunning,
  faVrCardboard,
  faBiking,
  faWalking,
  faHiking,
  faCheck,
  faCloudSun,
  faCloudUploadAlt,
  faUpload,
  faHome,
  faStar,
  faSearch,
  faChartPie,
  faChartBar,
  faEye,
  faFlag,
  faPlus,
  faBars,
  faPuzzlePiece,
  faIdBadge,
  faCalendarAlt,
  faClock,
  faCalendarCheck,
  faPlayCircle,
  faSlidersH,
  faTrophy,
  faUsers,
  faListOl,
  faCertificate,
  faQuestionCircle,
  faQuestion,
  faSignInAlt,
  faUser,
  faSignOutAlt,
  faNewspaper,
  faInfoCircle,
  faFlagCheckered,
  faCircle,
  faEnvelope,
  faEdit,
  faExternalLinkAlt,
  faChartLine,
  faChevronRight,
  faChevronLeft,
  faExclamationTriangle,
  faExclamationCircle,
  faSpinner,
  faChevronUp,
  faChevronDown,
  faGlobe,
  faVenus,
  faMars,
  faCalculator,
  faUndo,
  faMedal,
  faSync,
  faTable,
  faDownload,
  faTimes,
  faDesktop,
  faRedo,
  faFire,
  faDumbbell,
  faCalendarPlus,
  faCheckCircle,
  faCogs,
  faTimesCircle,
  faRoad,
  faRoute,
  faBolt,
  faTachometerAlt,
  faMap,
  faMapMarkedAlt,
  faBed,
  faCalendar,
  faBullseye,
  faUserCheck,
  faHeart,
  faHeartbeat,
  faMusic,
  faRobot,
  faShare,
  faComment,
  faSyncAlt,
  faUserCircle,
  faRocket,
  faImage,
  faVideo,
  faLock,
  faUnlock,
  faMagic,
  faPlay,
  faPause,
  faStarHalfAlt,
  faWeightHanging,
  faRuler,
  faMountain,
  faCrown,
  faTag,
  faCopy,
  faPhone,
  faHeadset
} from '@fortawesome/free-solid-svg-icons'

import {
  faYoutube,
  faStrava
} from '@fortawesome/free-brands-svg-icons'

import { BootstrapVue, IconsPlugin, ModalPlugin } from 'bootstrap-vue'
// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/styles/bootstrap-sport-brand.scss'

library.add(
  faSwimmer,
  faBiking,
  faRunning,
  faVrCardboard,
  faWalking,
  faHiking,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faArrowDown,
  faCheck,
  faCloudSun,
  faCloudUploadAlt,
  faUpload,
  faHome,
  faStar,
  faSearch,
  faChartPie,
  faChartBar,
  faEye,
  faFlag,
  faPlus,
  faBars,
  faPuzzlePiece,
  faIdBadge,
  faCalendarAlt,
  faClock,
  faCalendarCheck,
  faPlayCircle,
  faSlidersH,
  faTrophy,
  faUsers,
  faListOl,
  faCertificate,
  faQuestionCircle,
  faQuestion,
  faSignInAlt,
  faUser,
  faSignOutAlt,
  faNewspaper,
  faInfoCircle,
  faFlagCheckered,
  faCircle,
  faEnvelope,
  faEdit,
  faExternalLinkAlt,
  faChartLine,
  faChevronRight,
  faChevronLeft,
  faExclamationTriangle,
  faExclamationCircle,
  faSpinner,
  faChevronUp,
  faChevronDown,
  faGlobe,
  faVenus,
  faMars,
  faCalculator,
  faUndo,
  faMedal,
  faSync,
  faTable,
  faDownload,
  faTimes,
  faDesktop,
  faRedo,
  faFire,
  faDumbbell,
  faCalendarPlus,
  faCheckCircle,
  faCogs,
  faTimesCircle,
  faRoad,
  faRoute,
  faBolt,
  faTachometerAlt,
  faMap,
  faMapMarkedAlt,
  faBed,
  faCalendar,
  faBullseye,
  faUserCheck,
  faHeart,
  faHeartbeat,
  faMusic,
  faRobot,
  faShare,
  faComment,
  faSyncAlt,
  faUserCircle,
  faRocket,
  faImage,
  faVideo,
  faLock,
  faUnlock,
  faMagic,
  faPlay,
  faPause,
  faStarHalfAlt,
  faWeightHanging,
  faRuler,
  faMountain,
  faCrown,
  faTag,
  faCopy,
  faPhone,
  faHeadset
)

// Add brand icons
library.add(
  faYoutube,
  faStrava
)

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
// Modal Plugin
Vue.use(ModalPlugin)
// Meta plugin
Vue.use(VueMeta)

Vue.use(VueI18n)

const messages = { en, vi, ja, zh } // Added ja, zh

const savedLang = localStorage.getItem('lang')
const i18n = new VueI18n({
  locale: savedLang || 'vi', // default language
  fallbackLocale: 'en',
  messages
})

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

// Make router and store available globally for axios interceptor
const app = new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// Attach router and store to window for global access
window.$router = app.$router
window.$store = app.$store
